import React from 'react';

const CoreCrumb = () => <p>Core</p>;

export default CoreCrumb;
